"'use client';"
import React from 'react';

// Next.js
import Link from 'next/link';

// Components
import Avatar from './avatar';
import { UserMenuOptions } from '@ui/header/constants';
import LogoutButton from '@ui/header/logout';

// Store
import useStore from '@store';

export default function UserMenu() {
	const $state = useStore();
	const { user } = $state?.auth;
	let role = user?.profile?.member_type.toLowerCase();
	role === 'staff' && (role = 'parent'); // Staff members see parent options
	const options = UserMenuOptions[role] || [];

	return (
		<div className={`group flex flex-row items-center justify-center relative`}>
			<Avatar/>

			{/* This layer prevents glitchy behavion when hovering out of the menu element */}
			<div
				className={`fixed bg-transparent w-full h-[80px] left-0 z-2 -top-[3000px] transition-all duration-300 group-hover:top-0`}></div>

			{/* User Menu Options */}
			<div
				className={`flex flex-col items-start gap-1 border-4 border-[#E3E3EE] bg-[#EFEFEF] rounded-lg absolute -top-[3000px] transition-all duration-300 group-hover:top-full right-0 w-[300px] text-[#6666E1]`}>
				{options.map((option) =>
					option.label.toLowerCase() === 'logout' ? (
						<LogoutButton
							key={option.label.toLowerCase()}
							icon={option.icon}
							label={option.label}
							className='flex flex-row w-full items-center gap-2 font-bold text-lg py-2 px-4 transition-all duration-300 hover:bg-white'
						/>
					) : (
						<Link
							key={option.label.toLowerCase()}
							target={option.target || '_self'}
							href={option.link}
							className={`flex flex-row w-full items-center gap-2 font-bold text-lg py-2 px-4 transition-all duration-300 hover:bg-white`}>
							{option.icon}
							<span>{option.label}</span>
						</Link>
					)
				)}
			</div>
		</div>
	);
}
